import React, {FC} from "react";


interface PaginationItemProps {
    pageNumber: number;
    isActive: boolean;
    onClick: (pageNumber: number) => void;
}

export const PaginationItem: FC<PaginationItemProps> = ({pageNumber, isActive, onClick}) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        onClick(pageNumber);
    };

    return (
        <li className={isActive ? 'active' : ''}>
                <span onClick={handleClick}>
                     <a href="">{pageNumber}</a>
                </span>
        </li>
    );
}